if (document.getElementById('stripe-form-wrapper')) {

  // console.log('Temporary Stripe integration running...');

  // // Hacked together Stripe integration for a last minute landing page
  // // -------------------------------------
  // // reference: https://stripe.com/docs/payments/integration-builder
  // // A reference to Stripe.js initialized with your real test publishable API key.

  // // var stripe = Stripe("pk_test_51GuZuAJSPf2Die0lvh52s17EryHGNUoVxREgekvYp04HVzn5HDASq8X25N5OtUx7FGksNfc7Rd9422x2lKO9MOtt00h52OB0gP");
  // var stripe = Stripe("pk_live_wwgGU7c4DJOmQXFJfyGEWonK000X4owv1a");

  // // Dom Elements
  // // -------------------------------------

  // var form               = document.getElementById("payment-form");
  // var submitBtn          = document.getElementById("submit");
  // var submitBtnText      = document.getElementById("button-text");
  // var emailField         = document.getElementById("email");
  // var nameField          = document.getElementById("name");
  // var schoolField        = document.getElementById("school");
  // var line1Field         = document.getElementById("line1");
  // var stateField         = document.getElementById("state");
  // var countrySelect      = document.getElementById("country");
  // var tcsCheckbox        = document.getElementById("tcs-checkbox");
  // var marketingCheckbox  = document.getElementById("marketing-checkbox");
  // var invalidSchoolMsg   = document.getElementById("school-field-error-msg");
  // var bwSpinner          = document.getElementById("bw-loading-spinner");
  // var paymentCompleteMsg = document.getElementById("payment-complete-message");
  // var paymentErrorMsg    = document.getElementById("payment-error-message");
  // var successRedirect    = form.getAttribute('data-success-redirect');

  // // Stripe boilderplate code: Part 1
  // // -------------------------------------
  // // From https://stripe.com/docs/payments/integration-builder

  // // Disable the button until we have Stripe set up on the page
  // submitBtn.disabled = true;

  // // “Elements” is Stripes off the shelf UI Library
  // var elements = stripe.elements();
  // var card = elements.create("card");
  // // Stripe injects an iframe into the DOM
  // card.mount("#card-element");
  // card.on("change", function (event) {
  //   // Disable the Pay button if there are no card details in the Element
  //   submitBtn.disabled = event.empty;
  //   document.querySelector("#card-errors").textContent = event.error ? event.error.message : "";
  //   overallValidity();
  // });

  // // !END Stripe boilderplate code: Part 1
  // // -------------------------------------

  // // Email & T&Cs: validation etc
  // // -------------------------------------

  // var emailIsValid = false;
  // var tcsAccepted  = false;

  // function cb_emailFieldChange(e) {
  //   emailIsValid = validateEmailFieldValue(emailField.value);
  //   if (!emailIsValid) {
  //     invalidSchoolMsg.classList.remove('dn');
  //   }
  //   else {
  //     invalidSchoolMsg.classList.add('dn');
  //   }
  //   overallValidity();
  // }

  // function validateEmailFieldValue(val) {
  //   var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //   var educationalEmailAddresses = ['.ac', '.edu', '.edu.au', 'brandwatch.com'];

  //   var isValidEmailAddress = regex.test(String(val).toLowerCase());

  //   if (isValidEmailAddress) {
  //     console.log('Email address valid: Is educational - ', educationalEmailAddresses.some(allowed => val.includes(allowed)));
  //     return educationalEmailAddresses.some(allowed => val.includes(allowed));
  //   }
  //   else {
  //     console.log('Email address invalid.');
  //     return false;
  //   }
  // }

  // function cb_tcsCheckboxChange() {
  //   tcsAccepted = tcsCheckbox.checked;
  //   overallValidity();
  // }

  // function overallValidity() {
  //   console.log('overall: ', tcsAccepted, emailIsValid, !!countrySelect.value);
  //   if (tcsAccepted && emailIsValid && !!countrySelect.value) {
  //     submitBtn.disabled = false;
  //   }
  //   else {
  //     submitBtn.disabled = true;
  //   }
  // }

  // tcsCheckbox.addEventListener('change', cb_tcsCheckboxChange);
  // emailField.addEventListener('change', cb_emailFieldChange);
  // emailField.addEventListener('keyup',  cb_emailFieldChange);
  // countrySelect.addEventListener('change', overallValidity);
  // cb_tcsCheckboxChange();
  // overallValidity();

  // // Stripe boilderplate code: Part 2
  // // -------------------------------------
  // // From https://stripe.com/docs/payments/integration-builder

  // form.addEventListener("submit", function(event) {
  //   event.preventDefault();

  //   var purchase = {
  //     // Note from Christian Parsons (cparsons@brandwatch.com, slack: @chparsons): “We use "queryname" as key“
  //     email: emailField.value,
  //     queryname: schoolField.value,
  //     items: [{ id: "BrandwatchForStudentsPackage1" }],
  //     tcsApproved: tcsCheckbox.checked,
  //     marketingApproved: marketingCheckbox.checked,
  //   };

  //   fetch("/wp-content/themes/brandwatch/src/core/endpoints/stripe.php", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json"
  //     },
  //     body: JSON.stringify(purchase)
  //   })
  //     .then(function(result) {
  //       return result.json();
  //     })
  //     .then(function(data) {
  //       // Complete payment when the submit button is clicked
  //       payWithCard(stripe, card, data.clientSecret);
  //     });
  // });

  // // Calls stripe.confirmCardPayment
  // // If the card requires authentication Stripe shows a pop-up modal to
  // // prompt the user to enter authentication details without leaving your page.
  // var payWithCard = function(stripe, card, clientSecret) {
  //   bwSpinner.classList.add('t-fade-in--active');
  //   stripe
  //     .confirmCardPayment(clientSecret, {
  //       payment_method: {
  //         card: card,
  //         billing_details: {
  //           "email": emailField.value,
  //           "name": nameField.value,
  //           "address": {
  //             "country": countrySelect.value,
  //             "line1": line1Field.value,
  //             "state": stateField.value,
  //           },
  //         },
  //       },
  //     })
  //     .then(function(result) {
  //       if (result.error) {
  //         // Show error to your customer
  //         showError(result.error.message);
  //       } else {
  //         // The payment succeeded!
  //         orderComplete(result.paymentIntent.id);
  //       }
  //     });
  // };
  // /* ------- UI helpers ------- */
  // // Shows a success message when the payment is complete
  // var orderComplete = function(paymentIntentId) {
  //   document.querySelector("button").disabled = true;
  //   window.location.href = successRedirect;

  //   // document
  //   //   .querySelector(".result-message a")
  //   //   .setAttribute(
  //   //     "href",
  //   //     "https://dashboard.stripe.com/test/payments/" + paymentIntentId
  //   //   );
  //   // document.querySelector(".result-message").classList.remove('dn');
  //   // paymentCompleteMsg.classList.add('t-fade-in--active');
  // };
  // // Show the customer the error from Stripe if their card fails to charge
  // var showError = function(errorMsgText) {
  //   bwSpinner.classList.remove('t-fade-in--active');
  //   paymentErrorMsg.classList.add('t-fade-in--active');

  //   // var errorMsg = document.querySelector("#card-errors");
  //   // errorMsg.textContent = errorMsgText;
  //   // setTimeout(function() {
  //   //   errorMsg.textContent = "";
  //   // }, 4000);
  // };

  // // !END Stripe boilderplate code: Part 2
  // // -------------------------------------

  // // Payment Modal
  // // -------------------------------------

  // var modalOpenBtn  = document.getElementById("js-modal-open-btn");
  // var modalCloseBtn = document.getElementById("js-modal-close-btn");
  // var modal         = document.getElementById("stripe-form-modal");

  // modalOpenBtn.addEventListener('click', function() {
  //   modal.classList.add('t-fade-in--active');
  // });

  // modalCloseBtn.addEventListener('click', function() {
  //   modal.classList.remove('t-fade-in--active');
  // });

}
